var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "MySliderEx",
      style: { "--slider-count": _setup.props.excursion.length },
    },
    [
      _c("div", { staticClass: "MySliderEx__head" }, [
        _c("div", { staticClass: "MySliderEx__head__title" }, [
          _vm._v(_vm._s(_setup.HaveNExcursion(_setup.props.excursion.length))),
        ]),
        _vm._v(" "),
        _setup.hasPrev || _setup.hasNext
          ? _c("nav", [
              _c(
                "button",
                {
                  staticClass: "MySliderEx__head__but",
                  class: { active: _setup.hasPrev, inactive: !_setup.hasPrev },
                  on: { click: _setup.prev },
                },
                [
                  _c(_setup.vDown, {
                    staticClass: "MySliderEx__head__but__svg left",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "MySliderEx__head__but",
                  class: { active: _setup.hasNext, inactive: !_setup.hasNext },
                  on: { click: _setup.next },
                },
                [
                  _c(_setup.vDown, {
                    staticClass: "MySliderEx__head__but__svg right",
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        _setup.VueHorizontal,
        {
          ref: "horizontal",
          staticClass: "horizontal MySliderEx__slider",
          attrs: { button: false },
          on: { "scroll-debounce": _setup.onScroll },
        },
        _vm._l(_setup.props.excursion, function (slide) {
          return _c(
            "div",
            { key: slide.id, staticClass: "MySliderEx__ex" },
            [
              _c("div", [_vm._v(_vm._s(slide.name))]),
              _vm._v(" "),
              _c(_setup.ExcursionInner, { attrs: { excursion: slide } }),
              _vm._v(" "),
              slide.description
                ? _c(_setup.MyModalExcursion, { attrs: { excursion: slide } })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }